import PropTypes from 'prop-types';
import React, { Component } from 'react';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

const keys = {};
export function configureInterpolation() {
  return {
    setParam(key, value) {
      keys[key] = value;

      if (process.env.NODE_ENV === 'development') {
        console.info(
          `------ %c[i18n]%c ------\n` +
          `Ajout d'une clé d'interpolation: ${key} avec pour valeur ${value}.\n` +
          `Nouvel object "keys": `,
          'background: #d9edf7; color: #31708f',
          keys
        );
      }
    },
    format(str) {
      Object.keys(keys).map((key) => str = str.replace(new RegExp(key, "g"), keys[key]));
      return str;
    }
  };
}

export default (funcName = 'setParam') => WrappedComponent => {
  const translateDisplayName = `Interpolate(${getDisplayName(WrappedComponent)})`;
  return class Interpolate extends Component {
    static contextTypes = {
      interpolate: PropTypes.object
    };

    static displayName = translateDisplayName;

    render() {
      if (typeof this.context.interpolate === 'undefined')
        throw new Error(
          `[i18n] Impossible de trouver "interpolate" dans le context.` +
          `Englobez le composant racine dans un <I18nProvider>.`
        );



      return <WrappedComponent {...this.props} {...{ [funcName]: this.context.interpolate.setParam }} />
    }
  }
};
